import { Card, Text } from "@ttc3k/trekker";
import { ClickableCardSurface } from "shared/components/atoms";
import { Flex } from "styled-system/jsx";

type SelectItemCardProp = {
  selected?: boolean;
  mainText: string;
  subText?: string;
  onClick?: () => void;
};

export const SelectItemCard = ({
  mainText,
  selected,
  subText,
  onClick,
}: SelectItemCardProp) => {
  return (
    <ClickableCardSurface onClick={onClick} data-selected={selected}>
      <Card.Body>
        <Card.BodyContent>
          <Flex flexDir={"column"} gap={"100"}>
            <Text visual={"bodySemiBold"} color={"text.dark"} lineClamp={2}>
              {mainText}
            </Text>
            <Text visual={"smallMedium"} lineClamp={2} color={"text.light"}>
              {subText}
            </Text>
          </Flex>
        </Card.BodyContent>
      </Card.Body>
    </ClickableCardSurface>
  );
};
